import { Badge } from "@/components/ui/badge";
import {
  GaugeIcon,
  SatelliteDish,
  DatabaseIcon as SizeIcon,
  WifiIcon,
} from "lucide-react";
import { formatBytes, formatThroughput } from "./utils";

export interface McpStatusBadgesProps {
  isStreaming: boolean;
  errorCount: number;
  totalBytes?: number;
  throughput?: number;
  duration?: number;
}

export function McpStatusBadges({
  isStreaming,
  errorCount,
  totalBytes,
  throughput,
  duration,
}: McpStatusBadgesProps) {
  return (
    <div className="flex flex-wrap gap-1">
      <Badge
        variant="outline"
        className="text-xs text-muted-foreground p-2 px-2 gap-1"
        title={"Response type"}
      >
        <SatelliteDish className="h-4 w-4 text-foreground" />
        {isStreaming ? "Streaming" : "Non-Streaming"}
      </Badge>

      {errorCount > 0 && (
        <Badge variant="destructive" className="text-xs p-1 px-2 gap-1">
          {errorCount} errors
        </Badge>
      )}

      {totalBytes !== undefined && (
        <Badge
          variant="outline"
          className="text-xs text-muted-foreground p-2 px-2 gap-1"
          title={"Total bytes"}
        >
          <SizeIcon className="h-4 w-4 text-foreground" />
          {formatBytes(totalBytes)}
        </Badge>
      )}

      {throughput !== undefined && (
        <Badge
          variant="outline"
          className="text-xs text-muted-foreground p-2 px-2 gap-1"
          title={"Throughput speed"}
        >
          <WifiIcon className="h-4 w-4 text-foreground" />
          {formatThroughput(throughput)}
        </Badge>
      )}

      {duration !== undefined && (
        <Badge
          variant="outline"
          className="text-xs text-muted-foreground p-2 px-2 gap-1"
          title={"Duration of the response"}
        >
          <GaugeIcon className="h-4 w-4 text-foreground" />
          {duration} ms
        </Badge>
      )}
    </div>
  );
}
